
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_1lm1w_93",
  "input": "awsui_input_2rhyz_1lm1w_97",
  "input-readonly": "awsui_input-readonly_2rhyz_1lm1w_118",
  "input-invalid": "awsui_input-invalid_2rhyz_1lm1w_179",
  "input-has-icon-left": "awsui_input-has-icon-left_2rhyz_1lm1w_190",
  "input-type-search": "awsui_input-type-search_2rhyz_1lm1w_195",
  "input-has-icon-right": "awsui_input-has-icon-right_2rhyz_1lm1w_213",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_1lm1w_216",
  "input-container": "awsui_input-container_2rhyz_1lm1w_220",
  "input-icon": "awsui_input-icon_2rhyz_1lm1w_225",
  "input-icon-hoverable": "awsui_input-icon-hoverable_2rhyz_1lm1w_228",
  "input-icon-left": "awsui_input-icon-left_2rhyz_1lm1w_232",
  "input-icon-right": "awsui_input-icon-right_2rhyz_1lm1w_237"
};
  